import { Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { Headers, Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ContentService {

    private baseUrl = '/api/content/';
    private notFoundRedirect = 'page-not-found';

    private header = new RequestOptions({ headers: new Headers() });
    private jsonHeader = new RequestOptions({ headers: new Headers({ 'Content-Type': 'application/json' }) });
    private noCacheHeader = new RequestOptions({headers: new Headers({ 'Cache-control': 'private, no-cache, no-store, max-age=0, must-revalidate' })});

    constructor(private http: Http, private router: Router) {}

    private cacheControl(noCache){
        if(noCache){    
            return this.noCacheHeader;
        }
        return this.header;
    }

    findContents(type: string, elements: string, noCache?: boolean) {
        return this.http.get('/api/contents/'+type+'/'+elements, this.cacheControl(noCache))
            .toPromise()
            .then(response => {
                //console.log(response.json());
                return response.json();
            })
            .catch(this.handleError);
    }

    // /api/contents/record/tag/featured
    getContentsByField(type: string, field: string, value: string, noCache?: boolean) {
        return this.http.get('/api/contents/'+type+'/'+field+'/'+value, this.cacheControl(noCache))
            .toPromise()
            .then(response => {
                //console.log(response.json());
                return response.json();
            })
            .catch(this.handleError);
    }
    // /api/contents/page
    getContents(type: string, noCache?: boolean) {
        return this.http.get('/api/contents/'+type, this.cacheControl(noCache))
            .toPromise()
            .then(response => {
                //console.log(response.json());
                return response.json();
            })
            .catch(this.handleError);
    }

    getContent(type: string, fieldObj: Object, noCache?: boolean): Promise<any> {
        var fieldType = Object.keys(fieldObj)[0];
        var fieldValue = fieldObj[fieldType];
        let queryUrl = this.baseUrl + type+'/'+fieldType+'/'+fieldValue;
        // "this" can't be used in error callback
        let redirect = () => {this.router.navigateByUrl(this.notFoundRedirect);}
        let handleError = (e) => {this.handleError(e);}
        return this.http.get(queryUrl, this.cacheControl(noCache))
            .toPromise()
            .then(response => {
                return response.json()
            })
            .catch(function(e){
                //if(e.status==404) redirect();
                if(e.status==404) return {error: 404};
                else handleError(e);
            });
    }

    deleteContent(type: string, id: string): Promise<any> {
        let queryUrl = this.baseUrl + type+'/delete/'+id;
        return this.http.get(queryUrl)
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(this.handleError);
    }

    saveContent(type: string, action: string, data: any): Promise<any> {
        let $newId;
        // action: add OR update
        return this.http.post('/api/content/'+type+'/'+action, data, this.jsonHeader)
            .toPromise()
            .then(response => {
                //console.log(response.json()); 
                return response
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/content.service.ts